import { render, staticRenderFns } from "./Editor_config.vue?vue&type=template&id=653c26ab&"
import script from "./Editor_config.vue?vue&type=script&lang=js&"
export * from "./Editor_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports